import React from 'react';
import { useState, useEffect } from 'react';
import barChart from '../../../../assets/icons/bar-chart-square-02.png';
import arrow from '../../../../assets/icons/arrow-up.png';
import search_icon from '../../../../assets/icons/search_icon.png';
import plus from '../../../../assets/icons/plus.png';
import { Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  Form,
  Input,
  Button,
  Row,
  Col,
  Steps,
  Upload,
  message,
  Select,
  Space,
} from 'antd';
import step_base_icon from '../../../../assets/icons/step_base_icon.png';
import edit_icon from '../../../../assets/icons/edit_icon.png';
import view_icon from '../../../../assets/icons/view_icon.png';
import download_icon from '../../../../assets/icons/download_icon.png';
import arrow_down from '../../../../assets/icons/arrow_down.png';
import {
  getProjectList,
  getBbsList,
  getProjectCount,
} from '../../redux/slice.js';
import { getViewProject } from '../../../dashboard/redux/slice.js';
import { useSelector, useDispatch } from 'react-redux';
import TextArea from 'antd/es/input/TextArea';
import { useParams } from "react-router-dom";

const { Step } = Steps;


const ViewRequestApproval = () => {
    const [stepStyle, setStepStyle] = useState({ width: 'auto' });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Option } = Select;
  const { TextArea } = Input;

  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});

  const [currentStep, setCurrentStep] = useState(0);

  const [isStepperFormVisible, setIsStepperFormVisible] = useState(false);

  const [selectedLocationName, setSelectedLocationName] = useState('');
  const [selectedProjectName, setSelectedProjectName] = useState(null);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [isSingleProjectCode, setIsSingleProjectCode] = useState(false);
  const { projectCode } = useParams();


  // const handleProjectNameChange = (value) => {
  //     setSelectedProjectName(value);
  // };

  const projectData = useSelector((state) => state.projectList.projectData);  // Access the data from Redux
     const { viewProject} = useSelector(
      (state) => state.projectList,
    );
    
    console.log("view project in requester: ",viewProject)


  useEffect(() => {
    if (projectData) {
      console.log('Project Data:', projectData);
      // You can now populate the form or display the project data on the page
    }
  }, [projectData]);
  
    useEffect(() => {
      dispatch(getViewProject({projectCode}));
    }, [dispatch,projectCode]);
 

  

  const nextStep = (values) => {
    console.log('Values passed:', values); // Add this to debug
    setFormData((prevData) => {
      const updatedData = { ...prevData, ...values };
      console.log('Updated data:', updatedData);
      return updatedData;
    });
  
    setIsStepperFormVisible(false);
  };
  

  useEffect(() => {
    console.log('Form data updated:', formData);
  }, [formData]);

  const clearform = () => {
    form.resetFields();
  };

 

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width < 575) {
        setStepStyle({ width: 'auto' });
      } else if (width < 768) {
        setStepStyle({ width: '100%' });
      } else {
        setStepStyle({ width: 'auto' });
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const steps = [
    {
      title: <div className="step-title">BBS Creation</div>,
      content: (
        <Form form={form} layout="vertical">
          <Row gutter={24}>
          <Col span={12} xs={24} sm={12}>
              <Form.Item label="Project Code"
               //name="project_id"
               >
              <Input value={viewProject?.project_code} disabled/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Project Name"
                //name="project_name"
                //rules={[{ required: true, message: 'Please select a project' }]}
              >
               <Input value={viewProject?.project_name} disabled/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="SBG"
                //name="sbg_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
               <Input value={viewProject?.sbg} disabled/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="SBU"
                //name="sbu_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
                <Input value={viewProject?.sbu} disabled/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="BU"
                //name="bu"
                //rules={[{ message: 'Please enter the project name' }]}
              >
               <Input value={viewProject?.bu} disabled/>
              </Form.Item>
            </Col>
           
           
           

            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Total Reinforcement Quantity (in MT)"
                //name="sbg_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
               <Input value={viewProject?.quantity} disabled/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Budgeted Wastage in PET/CB/CTC* (in %)"
                //name="sbg_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
               <Input value={viewProject?.wastagePer} disabled/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Role of Employee"
                //name="sbg_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
               <Input value={viewProject?.role} disabled/>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
  <Col span={24} xs={24} sm={24}>
    <Form.Item
      label="Remarks"
      //name="sbg_id"
    >
      <TextArea rows={3} value={viewProject?.manager_project_remarks} disabled/>
    </Form.Item>
  </Col>
</Row>
        </Form>
      ),
    },
  ];
  return (
    <div className="main-div">
      <div className="step-card flex justify-center items-center ">
        <div className="steps_content_parent ">
          <Card className='lg:mt-5'>
            <div className="steps-content">
              {steps[currentStep] ? (
                steps[currentStep].content
              ) : (
                <div>No content available</div>
              )}
            </div>
            <div className="steps-action text-center mt-4">
              {currentStep === 0 && (
                <>
                  <Button
                    style={{ margin: '0 2px' }}
                    onClick={()=>navigate(-1)}
                    className="prev-button bg-white text-blue-800 rounded-lg px-4 py-2"
                  >
                    Close
                  </Button>
                  
                </>
              )}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ViewRequestApproval;

